import {LoadingState} from '@/types'

export interface IAIChatMessengerStore {
    loadingState: LoadingState
    authToken: string | null
    authTokenExpiresAt: number | null
    isAuthenticated: boolean

    initializeAuth(): Promise<void>
    refreshAuthToken(): Promise<void>
    clearAuth(): void
}

export const AIChatMessengerStoreSymbol = Symbol.for('AIChatMessengerStore')
